import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserGroupIconSolid = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "a",
	xmlns: "http://www.w3.org/2000/svg",
	width: 90,
	height: 72,
	viewBox: "0 0 90 72",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M63,67.12c0,2.7-2.18,4.88-4.88,4.88H4.87c-2.69,0-4.87-2.18-4.87-4.88,0-13.46,10.91-24.37,24.37-24.37h14.26c13.46,0,24.37,10.91,24.37,24.37ZM13.5,18C13.5,8.06,21.56,0,31.5,0s18,8.06,18,18-8.06,18-18,18S13.5,27.94,13.5,18Zm36.06,13.32c2.76-3.74,4.44-8.32,4.44-13.32,0-3.74-1.01-7.22-2.63-10.33,2.63-1.96,5.85-3.17,9.38-3.17,8.7,0,15.75,7.05,15.75,15.75s-7.05,15.75-15.75,15.75c-4.39,0-8.34-1.8-11.19-4.68Zm40.44,36.06c0,2.6-2.01,4.63-4.5,4.63h-19.41c.87-1.42,1.41-3.08,1.41-4.88,0-8.89-4.05-16.82-10.51-22.12h10.39c12.56,0,22.63,10.07,22.63,22.37Z" })]
});
const ForwardRef = forwardRef(SvgUserGroupIconSolid);
export default ForwardRef;
